<script lang="ts">
    
    import { createEventDispatcher } from 'svelte';
    import { Link } from 'svelte-navigator';
    import type { Route } from '../global';
    import { routes } from '../Routes';
    import RouteMeta from './RouteMeta.svelte';

    const dispatch = createEventDispatcher();

    export let current: string = undefined;

    function onClick(route: Route) {
        dispatch('click', route);
    }

</script>

{#each [...routes.values()] as route}
    <div class="route" class:current={current === route.id} on:click={() => onClick(route)}>
        <Link to="/mapa/{route.id}">
            <div class="name">{route.name}</div>
            <div class="d-flex gap-2">
                <RouteMeta {route} size="50px" />
            </div>
        </Link>
    </div>
{/each}

<style lang="scss">

    @use '../variables';
    @use 'sass:color';

    .route {

        & + .route {
            margin-top: 0.25rem;
        }

        :global(a) {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            color: #fff;
            background-color: variables.$color-secondary;
            text-decoration: none;
            padding: 0.5rem;
            border-radius: 0.5rem;
        }

        &.current {

            :global(a) {
                background-color: color.adjust(variables.$color-secondary, $lightness: 20%);
            }

        }
    }

</style>
